export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/de845080643c1ac8615c1e615d8de562.jpg" 
          alt="El Paso Home Construction" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Find Trusted El Paso Contractors for Your Home Project
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-10 max-w-3xl mx-auto font-light">
          Vetted Local Pros, Verified Reviews, and Essential Guides for Homeowners
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a href="#contractors" className="px-8 py-4 bg-teal-600 text-white text-base font-semibold rounded-lg hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap">
            Browse Contractor Directory
          </a>
          <a href="#guides" className="px-8 py-4 bg-white text-gray-900 text-base font-semibold rounded-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap">
            Get Free Remodeling Checklist
          </a>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-3xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2">500+</div>
            <div className="text-white/90 text-sm">Verified Contractors</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2">10,000+</div>
            <div className="text-white/90 text-sm">Projects Completed</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2">98%</div>
            <div className="text-white/90 text-sm">Customer Satisfaction</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/80"></i>
      </div>
    </section>
  );
}
